import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { appActions } from '../actions/AppAction'
import { AppState } from '../store'
import generateList from '../generateList'

export interface Nutrition {
    name: string;
    value: number;
}

export interface ItemState {
    id: number,
    selecetd: boolean,
    name: string;
    nutrients: Nutrition[];
}

const list = generateList();
const initialState: AppState = {
    items: list,
};

const toggleSelected = (items: ItemState[], id: number): ItemState[] => (
    items.map(i => {
        if (i.id === id) {
            i.selecetd = !i.selecetd;
        }
        return i;
    })
)

export const reducer = reducerWithInitialState(initialState)
    .case(appActions.toggleSelected, (state: AppState, id: number) => {
        return { items: toggleSelected(state.items, id) };
    });

// export default reducerWithInitialState(initialState)
//     .case(appActions.toggleSelected, (state: AppState, id: number) => ({
//         ...state,
//         items: toggleSelected(state.items, id)
//     }))
//     .build();